.wrapper {
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  background: var(--bg-inset);
  overflow: hidden;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--border-subtle);
  font-size: var(--text-xs);
  color: var(--text-tertiary);
}

.jump {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.jumpInput {
  width: 110px;
  height: 28px;
  padding: 0 var(--space-2);
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm);
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  color: var(--text-primary);
}

.viewport {
  height: 320px;
  overflow: auto;
  position: relative;
}

.spacer {
  position: relative;
}

.rows {
  position: absolute;
  left: 0;
  right: 0;
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  line-height: 22px;
}

.row {
  display: flex;
  gap: var(--space-4);
  padding: 0 var(--space-3);
  white-space: pre;
}

.row:nth-child(even) {
  background: var(--bg-hover);
}

.index {
  color: var(--text-tertiary);
  text-align: right;
  flex-shrink: 0;
  user-select: none;
}

.values {
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
  overflow: hidden;
}
